import React, { Component } from 'react';
// import Select from 'react-select'

class TransactionInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // accounts: [],
            // currentAccount: 0,
        };
    
        // let currentAccount = localStorage.getItem('currentAccount');
        // if (currentAccount) {
        //     this.state.currentAccount = parseInt(currentAccount, 10);
        // }
    
        // this.handleChange = this.handleChange.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
      }
    
      render() {
            return  <div className="row transaction-input">
                        <div className="col-xs-12 col-sm-5 col-md-4 col-xl-3">
                              <form onSubmit={this.handleSubmit}>
        <label>
          <input  onChange={this.handleChange} />
        </label>
        <input type="submit" value="Submit" />
      </form>
                        </div>
                    </div>
        }
}

export default TransactionInput;


// WEBPACK FOOTER //
// ./src/Components/Ledger/TransactionInput.js